import { render, staticRenderFns } from "./HosequptDetail.vue?vue&type=template&id=2146e708&scoped=true"
import script from "./HosequptDetail.vue?vue&type=script&lang=js"
export * from "./HosequptDetail.vue?vue&type=script&lang=js"
import style0 from "./HosequptDetail.vue?vue&type=style&index=0&id=2146e708&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2146e708",
  null
  
)

export default component.exports